import { fetchV1 } from "../lib/requester/v1";

export function getAll(params, options) {
	return fetchV1("/answers", { method: "GET", data: params }, options);
}

export function removeAnswer(id) {
	return fetchV1(`/answers/${id}`, { method: "DELETE" });
}
